import type { TabKey } from './types';

type TabButtonProps = {
  label: TabKey;
  active: boolean;
  onClick: () => void;
};

const TabButton = ({ label, active, onClick }: TabButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    className={`rounded-[12px] px-4 py-2 text-sm font-semibold transition ${
      active
        ? 'bg-slate-100 text-slate-900'
        : 'text-slate-500 hover:text-slate-700'
    }`}
  >
    {label}
  </button>
);

export default TabButton;
